/**
 * requiredParams => 必传参数，如果url没有携带requiredParams的参数则无法初始化页面
 * optionalParams => 可选参数
 */
module.exports = {
  index: {
    title: '', // 帮助中心
    requiredParams: {},
    optionalParams: {}
  },
  search: {
    title: '', // 帮助中心
    requiredParams: {},
    optionalParams: {}
  },
  detail: {
    title: '', // 帮助中心
    requiredParams: {
      id: 'url必须携带文章id'
    },
    optionalParams: {}
  },
  'privacy-policy': {
    title: '', // 隐私政策
    requiredParams: {},
    optionalParams: {}
  },
  'privacy-policy-sz': {
    title: '', // 隐私政策 - 深圳
    requiredParams: {},
    optionalParams: {}
  },
  'privacy-policy-cn': {
    title: '', // 隐私政策 - 境内
    requiredParams: {},
    optionalParams: {}
  },
  'privacy-policy-google': {
    title: '', // 隐私政策 - googlePlay
    requiredParams: {},
    optionalParams: {}
  },
  'provision-statement': {
    title: '', // 服务协议
    requiredParams: {},
    optionalParams: {}
  },
  'provision-statement-cn': {
    title: '', // 服务协议 - 境内
    requiredParams: {},
    optionalParams: {}
  },
  'provision-statement-google': {
    title: '', // 服务协议 - googlePlay
    requiredParams: {},
    optionalParams: {}
  },
  'analyst-rule': {
    title: '', // 分析师规则
    requiredParams: {},
    optionalParams: {}
  },
  'cancel-account': {
    title: '', // 注销账号
    requiredParams: {},
    optionalParams: {}
  },
  'quote-service': {
    title: '', // 盈宝行情服务协议
    requiredParams: {},
    optionalParams: {}
  },
  'third-party-share': {
    title: '', // 第三方共享信息情况说明
    requiredParams: {},
    optionalParams: {}
  },
  'third-party-share-cn': {
    title: '', // 第三方共享信息情况说明(大陆渠道) - 境内
    requiredParams: {},
    optionalParams: {}
  },
  'third-party-share-google': {
    title: '', // 第三方共享信息情况说明(googlePlay)
    requiredParams: {},
    optionalParams: {}
  },
  'biometric-authentication': {
    title: '', // 生物认证服务条款
    requiredParams: {},
    optionalParams: {}
  },
  'community-rule': {
    title: '', // 社区规则
    requiredParams: {},
    optionalParams: {}
  },
  'community-rule-cn': {
    title: '', // 社区规则 - 境内
    requiredParams: {},
    optionalParams: {}
  },
  'community-privilege-rule': {
    title: '', // 社区权益规则
    requiredParams: {},
    optionalParams: {}
  },
  'community-income-rule': {
    title: '', // 社区收益规则
    requiredParams: {},
    optionalParams: {}
  },
  'event-terms': {
    title: '', // 活动条款
    requiredParams: {},
    optionalParams: {}
  },
  'ipo-subscription-statement': {
    title: '', // 新股认购声明
    requiredParams: {},
    optionalParams: {}
  },
  'condition-order-disclaimer': {
    title: '', // 条件单风险声明
    requiredParams: {},
    optionalParams: {}
  },
  'trade-term': {
    title: '', // 交易术语说明
    requiredParams: {},
    optionalParams: {}
  },
  'financing-power-explain': {
    title: '', // 融资购买力说明
    requiredParams: {},
    optionalParams: {}
  }
}
